import {Box, Paragraph, Heading} from 'grommet'
import {DocumentMissing} from 'grommet-icons'
import { FormattedMessage } from 'react-intl'

import CenteredMain from '../../../components/layout/CenteredMain'
import Page from '../../../components/layout/Page'

function Error404() {
  return (
    <Page titleTranslation="page.status.title">
      <CenteredMain>
        <Box align="center">
          <Heading level="2" size="medium" color="status-warning" textAlign="center" margin={{
            bottom: 'none',
            top: 'medium'
          }}><FormattedMessage id="errors.404.title" /></Heading>

          <Paragraph textAlign="center" margin={{top: 'medium', bottom: 'xsmall'}}><DocumentMissing color="status-warning" size="large" /></Paragraph>

          <Paragraph size="large" textAlign="center"><FormattedMessage id="errors.404.description" /></Paragraph>
        </Box>
      </CenteredMain>
    </Page>
  )
}

export default Error404
